import React, { useState, useEffect } from 'react'
import { Modal } from 'rsuite'
import CheckboxComponent from '../../CommonComponents/CheckboxComponent'
import AdvanceAcceptanceDetailsContent from './advance-acceptance-details-content'

const AdvanceAcceptanceDetailsModal = ({ deliveryMethodTabs, show, onClose, deliveryMethodValues, handleDeliveryMethodsChange, deliveryMethodFeeValues, setDeliveryMethodsFeeValues }) => {
    const defaultFeeSettings = {
        isAcceptAmericanExpress: false,
        isAcceptVisa: false,
        isAcceptMasterCard: false,
        processingFeeType: '$',
        processingFeeValue: '',
        minPaymentFeeType: '$',
        minPaymentFeeValue: '',
        minPaymentAmount: '',
        maxPaymentFeeType: '$',
        maxPaymentFeeValue: '',
        maxPaymentAmount: '',
        incrementalFeeType: '$',
        incrementalFeeValue: '',
        incrementalPaymentAmount: '',
        tokenType: 'single-use-max-amount',
        secondProcessingFeeType: '$',
        secondProcessingFeeValue: '',
        isAcceptVariableFee: null
    }

    useEffect(() => {
        var selectedMethods = Object.entries(deliveryMethodValues).filter((val) => val?.[1] === true)
        const options = selectedMethods.map((value) => {
            return value[0]
        })

        let isOptionAlreadySet = (Object.keys(deliveryMethodFeeValues).length && options.length) ? options.some(val => Object.keys(deliveryMethodFeeValues).includes(val)) : false;
        setSelectedOptions(options)
        var disabledValues = {}
        var feeSettings = defaultFeeSettings
        if (isOptionAlreadySet) {
            Object.entries(deliveryMethodsDisabledValues).map((option) => {
                if (options.includes(option?.[0])) {
                    disabledValues = {
                        ...disabledValues,
                        [option?.[0]]: false
                    }
                    feeSettings = deliveryMethodFeeValues?.[option?.[0]]
                } else {
                    disabledValues = {
                        ...disabledValues,
                        [option?.[0]]: true
                    }
                }
            })
        } else {
            if (options.length) {
                Object.entries(deliveryMethodsDisabledValues).map((option) => {
                    if (Object.keys(deliveryMethodFeeValues).includes(option?.[0])) {
                        disabledValues = {
                            ...disabledValues,
                            [option?.[0]]: true
                        }
                    } else {
                        disabledValues = {
                            ...disabledValues,
                            [option?.[0]]: false
                        }
                    }
                })
            } else {
                Object.entries(deliveryMethodsDisabledValues).map((option) => {
                    disabledValues = {
                        ...disabledValues,
                        [option?.[0]]: false
                    }
                })
            }
        }
        setDeliveryMethodsDisabledValues(disabledValues)
        setFeeSettings(feeSettings)
    }, [deliveryMethodValues])

    useEffect(() => {
        if (Object.keys(deliveryMethodFeeValues).length === 0) {
            return
        } else {
            Object.keys(deliveryMethodFeeValues).map((key) => {
                if (key === 'email') {
                    setEmailFeeInfo(deliveryMethodFeeValues?.email)
                } else if (key === 'phone') {
                    setPhoneFeeInfo(deliveryMethodFeeValues?.phone)
                } else if (key === 'fax') {
                    setFaxFeeInfo(deliveryMethodFeeValues?.fax)
                } else if (key === 'online') {
                    setOnlineFeeInfo(deliveryMethodFeeValues?.online)
                } else {
                    setPosFeeInfo(deliveryMethodFeeValues?.pos)
                }
            })
            setFeeSettings(defaultFeeSettings)
        }
    }, [deliveryMethodFeeValues])


    // const [isOptionAlreadtSet, setIsOptionAlreadySet] = useState(false)
    const [selectedOptions, setSelectedOptions] = useState([])
    const [deliveryMethodsDisabledValues, setDeliveryMethodsDisabledValues] = useState({
        email: false,
        phone: false,
        fax: false,
        online: false,
        pos: false
    })

    const [feeSettings, setFeeSettings] = useState(defaultFeeSettings)
    const [emailFeeInfo, setEmailFeeInfo] = useState({})
    const [phoneFeeInfo, setPhoneFeeInfo] = useState({})
    const [faxFeeInfo, setFaxFeeInfo] = useState({})
    const [onlineFeeInfo, setOnlineFeeInfo] = useState({})
    const [posFeeInfo, setPosFeeInfo] = useState({})

    const updateFeeData = (colName, value, deliveryMethod, type, feeValueColumnName, feeValueType) => {
        var feeValue = ''
        if (type === 'number') {
            var temp = "";
            temp = value ? parseInt(value.replace(/\D/g, '')) : '';
            value = temp ? ((temp) / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
            if (feeValueType === '$') {
                if (! /^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/.test(value)) {
                    value = value?.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi) ? value.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi)[0] : ''
                }
            } else {
                if (! /^\d{0,2}(\.\d{0,2})?$/.test(value)) {
                    value = value?.match(/^\d{0,2}(\.\d{0,2})?/gi) ? value.match(/^\d{0,2}(\.\d{0,2})?/gi)[0] : ''
                }
            }
        }

        if (value === '$' || value === '%') {
            feeValue = getFeeValue(value, feeSettings?.[feeValueColumnName])
            setFeeSettings({ ...feeSettings, [colName]: value, [feeValueColumnName]: feeValue })
        } else {
            setFeeSettings({ ...feeSettings, [colName]: value })
        }
    }

    const getFeeValue = (value, feeValue) => {
        var feeVal = value === '%' ? feeValue && feeValue?.toString().match(/^\d{0,2}(\.\d{0,2})?/gi) ?
            parseInt(feeValue.replace(',', '').match(/^\d{0,2}(\.\d{0,2})?/gi)[0]).toFixed(2)
            : ''
            : feeValue

        return feeVal
    }

    return (
        <Modal
            backdrop='static'
            className="advance-acceptance-details-modal"
            show={show}
            size="md"
            onClick={onClose}
            onHide={onClose}
        >
            <Modal.Header>
                <Modal.Title className='text-blue fw-bold h3'>
                    Fee Structure
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='advance-acceptance-details-modal-content flex accept-list'>
                    <div className='left-content w-25 flex flex-column'>
                        <div className="page-tabs flex flex-column">
                            {
                                deliveryMethodTabs.map((tab, index) => (
                                    tab &&
                                    <div key={index}>
                                        <CheckboxComponent
                                            label={tab.label}
                                            onChange={(checked) => { handleDeliveryMethodsChange(checked, tab.value) }}
                                            checked={deliveryMethodValues[tab.value]}
                                            disabled={deliveryMethodsDisabledValues[tab.value]}
                                        />
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <div className='tabs-content right-content flex flex-column'>
                        <AdvanceAcceptanceDetailsContent
                            deliveryMethodName=''
                            deliveryMethodData={feeSettings}
                            updateFeeData={updateFeeData}
                            disabled={selectedOptions.length > 0 ? false : true}
                        />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className='apply-settings text-white float-left p-4 pt-3 pb-3 pt-sm-3 pb-sm-3 p-sm-5 h3' onClick={() => setDeliveryMethodsFeeValues(feeSettings, selectedOptions)}> Send </button>
            </Modal.Footer>
        </Modal>
    )
}

export default AdvanceAcceptanceDetailsModal;